module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "cn"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Interfacing")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("W")]), _vm._v("hen constructing a garment, "), _c('span', {
    attrs: {
      "href": "#/xhtml/15_Glossary#gloss59",
      "id": "gloss_59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("interfacing")]), _vm._v(" can be applied to the wrong side of the fabric pieces to provide shape and stability.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Interfacings come in light, medium and heavy weights and can be stitched or fused to the fabric. They may be woven or non-woven and consist of natural or synthetic fibres. The colours are limited to white, black, grey and ecru. Choose an interfacing that matches the care requirements and weight of your fabric, remembering that the interfacing should always be the same weight or lighter than the garment fabric and that your pattern may require more than one type. For sheer fabrics where interfacing may show through, another piece of the garment fabric is a good alternative to interfacing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are pre-cut interfacings for waistbands, cuffs and button bands. They have seamline and fold markings that make it easier to keep the seams and folds evenly spaced.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Woven interfacings are usually cut on the straight "), _c('span', {
    attrs: {
      "href": "#/xhtml/15_Glossary#gloss48",
      "id": "gloss_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("grain")]), _vm._v(", matching the grain of the fabric piece. Non-woven types have no grain and can be cut in any direction.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stretch non-woven interfacings have a certain amount of "), _c('span', {
    attrs: {
      "href": "#/xhtml/15_Glossary#gloss49",
      "id": "gloss_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("crosswise")]), _vm._v(" stretch, making them ideal for knit fabrics.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Interfacings are generally attached to facings or "), _c('span', {
    attrs: {
      "href": "#/xhtml/15_Glossary#gloss65",
      "id": "gloss_65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("linings")]), _vm._v(" but lightweight types often work better when applied to the garment pieces. Personal preference can play a large part in determining on what layer the interfacing is placed, bearing in mind that it should never be obvious on the right side of the garment.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-674c80ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Chapter04.vue
// module id = 78
// module chunks = 0